<template><div><h1 id="kapitel-4-verkauf-und-logistik" tabindex="-1"><a class="header-anchor" href="#kapitel-4-verkauf-und-logistik"><span>Kapitel 4. Verkauf und Logistik</span></a></h1>
<p>Dieser Teil beinhaltet die Bereiche Verkauf, Einkauf und die Logistik.</p>
</div></template>


